/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/26/19
 *
 */

export default Object.freeze({
	UNDEF: "UNDEF",
	NOT_SET: "NOT_SET",
	INTEGRATED: "INTEGRATED",
	DETACHED: "DETACHED",
})
